import { fetchPersea } from "@/config/axios/config-axios";

export const getCampaign = async (params = {}) => {
    return await fetchPersea(`campaigns`, 'GET', params);
};

export const getObjetiveByCampaign = async (params = {}) => {
    return await fetchPersea('campaign/objective', 'GET', params);
};

export const getCampaignObjective = async (params = {}) => {
    return await fetchPersea(`campaign/objective`, 'GET', params);
};

export const getCampaignNextMission = async (params = {}) => {
    return await fetchPersea(`campaign/mission/next`, 'GET', params);
};
